// Querys and Mutations
import {
  GET_MONTHLY_PAYROLL,
  GET_ALL_MONTHLY_PAYROLL_WITH_PAGINATION,
  GET_ITEMS_BY_MONTHLY_PAYROLL
} from '@/graphql/monthlyPayroll/queries'
import { CREATE, GENERATE, DELETE_PAYROLL, UPDATE_PAYROLL } from '@/graphql/monthlyPayroll/mutations'

// models
import {
  MonthlyPayrollModel,
  MonthlyPayrollGenerate
} from '@/models/monthlyPayroll'
import {
  MonthlyPayrollInput,
  MonthlyPayrollWithPagination
} from '@/models/monthlyPayroll/MonthlyPayrollModel'

// apollo
import { apolloClient } from '@/apollo'

class MonthlyPayrollService {
  /**
   * Queries
   */
  async getAllWithPagination (perPage: number, page: number): Promise<MonthlyPayrollWithPagination> {
    const result = await apolloClient.query({
      query: GET_ALL_MONTHLY_PAYROLL_WITH_PAGINATION,
      variables: {
        perPage,
        page
      }
    })
    return {
      objects: result.data.getAllMonthlyPayroll.data,
      pagination: result.data.getAllMonthlyPayroll.paginatorInfo
    }
  }

  async get (year: number, month: number): Promise<MonthlyPayrollModel|null> {
    const result = await apolloClient.query({
      query: GET_MONTHLY_PAYROLL,
      variables: {
        year: year,
        month: month
      }
    })
    return result.data.getMonthlyPayroll
  }

  async getItemsByPayrollId (id: number): Promise<MonthlyPayrollGenerate[]> {
    const result = await apolloClient.query({
      query: GET_ITEMS_BY_MONTHLY_PAYROLL,
      variables: {
        id
      }
    })
    return result.data.getItemsByMonthlyPayroll
  }

  async generate (year: number, month: number): Promise<MonthlyPayrollGenerate[]> {
    const result = await apolloClient.mutate({
      mutation: GENERATE,
      variables: {
        year: year,
        month: month
      }
    })
    return result.data.generateMonthlyPayroll
  }

  async create (input: MonthlyPayrollInput): Promise<MonthlyPayrollGenerate[]> {
    const result = await apolloClient.mutate({
      mutation: CREATE,
      variables: {
        input
      }
    })
    return result.data.createMonthlyPayroll
  }

  async update (id, input: MonthlyPayrollInput, is_refresh): Promise<MonthlyPayrollModel> {
    const result = await apolloClient.mutate({
      mutation: UPDATE_PAYROLL,
      variables: {
        input,
        id,
        is_refresh
      }
    })
    return result.data.updateMonthlyPayroll
  }

  async remove (id: number): Promise<MonthlyPayrollModel> {
    const result = await apolloClient.mutate({
      mutation: DELETE_PAYROLL,
      variables: {
        id
      }
    })
    return result.data.deleteMonthlyPayroll
  }
}

export default new MonthlyPayrollService()
